import s from './MyCheckbox.module.css';

export default function MyCheckbox({inputLabel, myRef, dataInput, changeAction}) {	
	return (<div style={{margin:"0 10px", display:"flex", alignItems:"center"}}>
		<input type="checkbox" ref={myRef} className={s.inputBox} value={dataInput} 
			onChange={(e)=> {
				changeAction(e.target.value);
			}} />
				{((dataInput == true) ) ? "is true" : "false"}
	</div>)
}


export function CheckboxSmall({label, isChecked, changeAction}) {
	return (
		<label className={s.containerSmall}>{label}
			<input type="checkbox" checked={isChecked} onChange={(e)=> {
				changeAction(e.target.value);
			}}/>
			<span className={s.checkmarkSmall}></span>
		</label>
	)
}